// -------------- SERVICE Page --------------
export const SERVICE_FIELD_ERROR       = 'SERVICE_FIELD_ERROR';
export const SERVICE_FIELD_RESET_ERROR = 'SERVICE_FIELD_RESET_ERROR';
export const SERVICE_SET_ITEM          = 'SERVICE_SET_ITEM';
export const SERVICE_GET_ITEM          = 'SERVICE_GET_ITEM';
export const SERVICE_SET_ALL           = 'SERVICE_SET_ALL';
export const SERVICE_ADD_ITEM          = 'SERVICE_ADD_ITEM';



// --------- SERVICE Page ---------
export function serviceFieldError(field, fieldData = {}) {
    return { type: SERVICE_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}
export function serviceFieldResetError(field, fieldData = {}) {
    return { type: SERVICE_FIELD_RESET_ERROR }
}
export function serviceGetItem(targetItem) {
    return { type: SERVICE_GET_ITEM, data: targetItem }
}
export function serviceSetItem(targetItem) {
    return { type: SERVICE_SET_ITEM, data: targetItem }
}
export function serviceAddItem(addItem) {
    return { type: SERVICE_ADD_ITEM, data: addItem }
}
export function serviceSetList(allSERVICE) {
    return { type: SERVICE_SET_ALL, data: allSERVICE }
}
